var _rect, _rect2, _path, _path2, _path3, _path4, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path5, _path6, _path7, _path8, _path9, _rect9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighstreet(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_46528",
    "data-name": "Group 46528",
    xmlns: "http://www.w3.org/2000/svg",
    width: 132.405,
    height: 17.399,
    viewBox: "0 0 132.405 17.399",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16649",
    "data-name": "Rectangle 16649",
    width: 4.733,
    height: 8.662,
    transform: "translate(8.043 8.662)",
    fill: "#1228f3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16650",
    "data-name": "Rectangle 16650",
    width: 3.787,
    height: 10.413,
    transform: "translate(16.094 6.985)",
    fill: "#1228f3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_99242",
    "data-name": "Path 99242",
    d: "M159.806,9.094h-3.712V6H153v9.9h3.094V12.806H162.9V6h-3.094Z",
    transform: "translate(-58.337 -2.288)",
    fill: "#1228f3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_99243",
    "data-name": "Path 99243",
    d: "M181.806,9.094h-3.712V6H175v9.9h3.094V12.806H184.9V6h-3.094Z",
    transform: "translate(-66.725 -2.288)",
    fill: "#1228f3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_99244",
    "data-name": "Path 99244",
    d: "M111.713,0V3.712H108V6.806h3.712V17.324h6.806V14.231h-3.713V6.806h3.713V3.712h-3.713V0Z",
    transform: "translate(-41.179 0)",
    fill: "#1228f3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_99245",
    "data-name": "Path 99245",
    d: "M130,0V17.324h3.094V6.806h3.713v3.712h3.712V3.712h-7.425V0Z",
    transform: "translate(-49.567 0)",
    fill: "#1228f3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16651",
    "data-name": "Rectangle 16651",
    width: 3.787,
    height: 3.787,
    transform: "translate(97.719)",
    fill: "#1228f3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16657",
    "data-name": "Rectangle 16657",
    width: 3.787,
    height: 3.787,
    transform: "translate(16.012)",
    fill: "#1228f3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16652",
    "data-name": "Rectangle 16652",
    width: 3.787,
    height: 3.787,
    transform: "translate(111.331)",
    fill: "#1228f3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16653",
    "data-name": "Rectangle 16653",
    width: 6.627,
    height: 3.787,
    transform: "translate(97.719 13.537)",
    fill: "#1228f3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16654",
    "data-name": "Rectangle 16654",
    width: 6.627,
    height: 3.787,
    transform: "translate(111.331 13.537)",
    fill: "#1228f3"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16655",
    "data-name": "Rectangle 16655",
    width: 3.787,
    height: 8.736,
    transform: "translate(45.091 8.662)",
    fill: "#1228f3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_99246",
    "data-name": "Path 99246",
    d: "M60,0V17.324h4.33V8.662h3.713V4.331H64.331V0Z",
    transform: "translate(-22.877 0)",
    fill: "#1228f3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_99247",
    "data-name": "Path 99247",
    d: "M200.713,0V3.712H197V6.806h3.712V17.324h6.806V14.231h-3.713V6.806h3.713V3.712h-3.713V0Z",
    transform: "translate(-75.113 0)",
    fill: "#1228f3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_99248",
    "data-name": "Path 99248",
    d: "M0,0V17.324H4.331V8.662H8.043V4.331H4.331V0Z",
    transform: "translate(0 0)",
    fill: "#1228f3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_99249",
    "data-name": "Path 99249",
    d: "M43.805,6.806H40.094V3.713h3.712ZM40.094,0V3.712H37v6.806h6.805v3.094H37v3.712H47.518V0Z",
    transform: "translate(-14.108)",
    fill: "#1228f3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_99250",
    "data-name": "Path 99250",
    d: "M88.712,0V3.094H85v7.425h7.425v3.094h3.094V6.806H88.712V3.712h7.425V0Z",
    transform: "translate(-32.409 0)",
    fill: "#1228f3"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16656",
    "data-name": "Rectangle 16656",
    width: 6.627,
    height: 3.787,
    transform: "translate(53.426 13.612)",
    fill: "#1228f3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighstreet);
export default __webpack_public_path__ + "static/media/highstreet.e04c7b04ebaf141db279396f86ec6782.svg";
export { ForwardRef as ReactComponent };